import { ApiResourceModel } from "../ApiResourceModel";
export class PagedCollection extends ApiResourceModel {
    constructor(args) {
        super();
        // super(args);
        this.content = args.content;
        this.first = args.first;
        this.last = args.last;
        this.numberOfElements = args.numberOfElements;
        this.totalElements = args.totalElements;
        this.totalPages = args.totalPages;
        this.sort = args.sort;
        this.size = args.size;
        this.number = args.number;
    }
}
